import { Accordion } from '@chakra-ui/react';
import { AnimatePresence } from 'framer-motion';
import { useEffect, useRef } from 'react';
import { AnimatedDiv } from '~/elements';
import { useFormState } from '~/hooks';
import { Result } from './individual';
import { Tags } from './tags';

export const Results = (): JSX.Element => {
  const { queryLocation } = useFormState(s => s.form);
  const setStatus = useFormState(s => s.setStatus);
  const containerRef = useRef<HTMLDivElement>(null);

  // Return to form view when user scrolls up inside the snap container.
  useEffect(() => {
    const snapEl = document.getElementById('__snap-container');
    if (!snapEl) return;

    let lastScrollTop = snapEl.scrollTop;
    let isAutoScrolling = true;

    const autoScrollTimer = setTimeout(() => {
      isAutoScrolling = false;
      lastScrollTop = snapEl.scrollTop;
    }, 1000);

    const handleScroll = () => {
      if (isAutoScrolling) return;
      const current = snapEl.scrollTop;
      if (current < lastScrollTop - 60) {
        // User scrolled up significantly — snap back to form
        isAutoScrolling = true;
        snapEl.style.scrollSnapType = 'none';
        snapEl.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => {
          setStatus('form');
          snapEl.style.scrollSnapType = 'y mandatory';
        }, 400);
      } else {
        lastScrollTop = current;
      }
    };

    snapEl.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      clearTimeout(autoScrollTimer);
      snapEl.removeEventListener('scroll', handleScroll);
    };
  }, [setStatus]);

  return (
    <div ref={containerRef} className="w-full max-w-3xl mx-auto">
      <Tags />
      <AnimatedDiv
        p={0}
        my={4}
        w="100%"
        mx="auto"
        rounded="lg"
        textAlign="left"
        overflow="hidden"
        initial={{ opacity: 1 }}
        exit={{ opacity: 0, y: 300 }}
        transition={{ duration: 0.3 }}
        animate={{ opacity: 1, y: 0 }}
        maxW="100%"
      >
        <Accordion allowMultiple defaultIndex={queryLocation.map((_, i) => i)}>
          <AnimatePresence>
            {queryLocation.length > 0 &&
              queryLocation.map((location, index) => {
                return <Result index={index} key={location} queryLocation={location} />;
              })}
          </AnimatePresence>
        </Accordion>
      </AnimatedDiv>
    </div>
  );
};
